import React, { useState } from "react";

const HeaderSelect = ({ activeItem, setActiveItem, options }) => {
  const [items, setItems] = useState(options);

  const onClickHandler = (e, value) => {
    e.preventDefault();

    setItems(
      items.map((item) => (item.value === value ? { ...item, active: true } : { ...item, active: false })),
    );
    setActiveItem(items.find((item) => item.value === value));
  };

  return (
    <div className="flex p-1 bg-neutral-20 gap-2 md:h-[53px] rounded-v-md pointer-events-auto md:min-w-[300px] max-w-full">
      {items.map((item) => (
        <button
          key={item.value}
          value={item.value}
          onClick={(e) => onClickHandler(e, item.value)}
          className={`flex-1 ${
            item.value === activeItem.value ? "bg-neutral-00" : ""
          } rounded-v-md flex justify-center items-center cursor-pointer hover:bg-slate-50 px-2`}
        >
          {item.title}
        </button>
      ))}
    </div>
  );
};

export default HeaderSelect;
